import { IDevicesState } from './devicesContext';
import { DevicesActionTypes, TDevicesActions } from './devicesActions';

export const devicesReducer = (state: IDevicesState, action: TDevicesActions): IDevicesState => {
	switch (action.type) {
		case DevicesActionTypes.SET_DEVICES:
			return {
				...state,
				devices: action.payload.devices,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case DevicesActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case DevicesActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				IDSelectedRestaurant: null,
				currentPage: 1,
			};
		case DevicesActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				currentPage: 1,
			};
		case DevicesActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				IDSelectedCustomer: null,
				IDSelectedRestaurant: null,
				currentPage: 1,
			};
		case DevicesActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case DevicesActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case DevicesActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case DevicesActionTypes.SET_DEVICE_ID_FOR_DELETION:
			return {
				...state,
				deviceIDForDeletion: action.payload.deviceIDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case DevicesActionTypes.SET_DEVICE_ID_FOR_FULL_INFO:
			return {
				...state,
				deviceIDForFullInfo: action.payload.deviceIDForFullInfo,
			};
		case DevicesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case DevicesActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		default:
			return state;
	}
};
